import React from "react";
import { View, Text, Button } from "ui";
import { styled } from "styles";
import { store } from "store";
import { Actions } from "../store/reducer";
import { NavLink } from "react-router-dom";
import AddMemoModal from "./AddMemoModal";
import PresentationModal from "./PresentationModal";

// this is the same as writing the items inside the components
// but I liked cuz it keeps them separated
// also, this variable couldve been written inside the component,
// giving it access to this without any problems
const PrimaryMenuItems = componentInstance => [
  {
    title: "Alerte",
    textColor: "primary",
    path: "/app/alerts",
    color: "white"
  },
  {
    title: "Memo",
    textColor: "primary",
    path: "/app/memos",
    color: "white"
  },
  {
    title: " Setari",
    textColor: "primary",
    path: "/app/settings",
    color: "white"
  },
  {
    title: "Abonament",
    textColor: "primary",
    path: "/app/abonament",
    color: "white"
  },
  {
    title: "Prezentare",
    textColor: "primary",
    onClick: () => {
      componentInstance.showPresentation();
    },
    // path: "/app/prezentare",
    color: "white"
  },
  {
    title: "Intrebari Frecvente",
    textColor: "primary",
    path: "/app/faq",
    color: "white"
  },
  // {
  //   title: "Termeni si Conditii",
  //   textColor: "primary",
  //   path: "/app/tos",
  //   color: "white"
  // },
  {
    title: "Contact",
    textColor: "primary",
    path: "/app/contact",
    color: "white"
  },
  {
    title: "Iesi din Cont",
    textColor: "warning",
    path: "/app/logout",
    padding: "2rem",
    color: "white",

    onClick: () => {
      store.dispatch(Actions.setToken(null));
    }
  }
];
export default class Menu extends React.Component {
  public items = PrimaryMenuItems(this);

  public state = {
    presentationModal: false
  };

  public showPresentation = () => {
    this.setState({ presentationModal: true });
  }
  public hidePresentation = () => {
    this.setState({ presentationModal: false });
  }

  public render = () => {
    const { presentationModal } = this.state;
    return (
      <React.Fragment>
        <PresentationModal open={presentationModal} onClose={this.hidePresentation} />
        <Container flex={1} flexDirection="column">
          <View
            mb={4}
            mt={4}
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
          >
            <Image src={require("assets/logo.png")} />
          </View>
          {this.items.map(menuItem => (
            <MenuButton
              bg={menuItem.color}
              color={menuItem.textColor as any}
              onClick={menuItem.onClick}
              as={menuItem.path ? NavLink : undefined}
              exact={false}
              to={menuItem.path}
              flexDirection="row"
              justifyContent="flex-start"
            >
              <Text mr={2} fontWeight="bold" fontSize={2}>
                {menuItem.title}
              </Text>
            </MenuButton>
          ))}
        </Container>
      </React.Fragment>
    );
  }
}

const MenuButton = styled(Button)`
  text-decoration: none;
  border-radius: 0;
  border-bottom: #d3d3d3 5px solid;
  &.active {
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};
  }
  &:hover {
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};
  }
`;
const Container = styled(View)`
  min-height: 100vh;
  background-color: #d3d3d3;
`;

const Image = styled.img`
  max-width: 6rem;
  max-height: 6rem;
`;



// WEBPACK FOOTER //
// ./src/pages/Menu.tsx